const TOPICS = [
  { id: 1, name: '香蕉视频热门', heat: '9.8万', icon: 'ri-fire-line', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '糖豆视频新剧', heat: '8.5万', icon: 'ri-flashlight-line', color: 'bg-accent-100 text-accent-700' },
  { id: 3, name: '蓝莓视频经典', heat: '7.2万', icon: 'ri-star-line', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, name: '小蓝视频推荐', heat: '6.8万', icon: 'ri-thumb-up-line', color: 'bg-primary-100 text-primary-700' },
  { id: 5, name: '都市情感剧场', heat: '6.3万', icon: 'ri-heart-line', color: 'bg-accent-100 text-accent-700' },
  { id: 6, name: '悬疑烧脑合集', heat: '5.9万', icon: 'ri-search-eye-line', color: 'bg-secondary-100 text-secondary-700' },
  { id: 7, name: '古装巨制专题', heat: '5.4万', icon: 'ri-building-line', color: 'bg-primary-100 text-primary-700' },
  { id: 8, name: '高分电影大全', heat: '4.8万', icon: 'ri-award-line', color: 'bg-accent-100 text-accent-700' },
  { id: 9, name: '不缓冲专区', heat: '4.2万', icon: 'ri-speed-up-line', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-3">
            大家都在看
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            发现当下最热门的影视讨论与追剧风向
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-background-300/80 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${topic.color} flex items-center justify-center`}>
                <i className={`${topic.icon} text-base md:text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 text-center leading-snug whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.heat} 热度</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}